import React from 'react';
import { withRouter } from "react-router";
import moment from 'moment';
import ellipsisContent from "../../utils/EllipsisContent";
import globalStyle from "../../styles/globalStyle";
import ellipsis from "../../styles/ellipsis.module.css";

const NewsItem = (props) => {
    const { history, url, id, cover_link, title, change_time, content } = props;

    return (
        <div
            key={id}
            style={{display: 'flex', padding: 16,cursor:'pointer'}}
            onClick={() => {
                window.scrollTo(0,300);
                history.push({ pathname: `${url}/detail/${id}`});
            }}
        >
            <img src={cover_link} style={{width: 180, height: 120}}/>
            <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', paddingLeft: 16, width: 692}}>
                <div style={{...globalStyle.flexSpaceBetweenRow,marginBottom: 16}}>
                    <span style={{fontSize: 18, fontWeight: 400, color: '#333333',whiteSpace: 'nowrap',overflow:'hidden',textOverflow:'ellipsis',maxWidth: 560}}>{title}</span>
                    <span>{moment(change_time).format('YYYY-MM-DD')}</span>
                </div>
                <span className={ellipsis.ellipsis} style={{lineHeight: '25px', height: 50}}>
                    {ellipsisContent(content)}
                </span>
            </div>
        </div>
    );
};

export default withRouter(NewsItem);
